export const getNewState = function() {
  return {
    mouseHasMoved:false,
    active: false,
    suggestions: [],
    index: 0 // current active suggestion index
  };
};
